import type { BreadcrumbItem } from '@/cms/fields/types/common'
import { useCMSPageField } from '@/cms/fields'
import { mqMin, space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Button, Icon, Typography } from '@sunwebgroup/ui-components/uds'
import styled from 'styled-components'

interface BreadcrumbProps {
  items?: BreadcrumbItem[]
}

const Wrapper = styled.div`
  grid-column: span 1;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    grid-column: span 2;
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    grid-column: span 3;
  }
`
const StyledLine = styled.div`
  width: 100%;
  border-top: ${tokPx('semantics_dividers_tickness')} solid ${tok('primitives_color_neutral_200')};
  margin: ${space('primitives_space_16')} auto;
`

const ListWrapper = styled.ol`
  list-style: none;
  flex-wrap: wrap;
  display: flex;
  margin: unset;
  padding: unset;

  & > li:first-child{
    ${Typography} {
      text-decoration-line: underline;
    }
  }
`
const ButtonElement = styled(Button)`
  ${Typography} {
    // Override UDS Button styles due to styled-components specificity issues
    font-weight: 500 !important;
  }
`

export default function BreadcrumbInFooter({ items }: BreadcrumbProps) {
  const data = useCMSPageField('Breadcrumb.elements')
  let elements: BreadcrumbItem[] = []

  if (!items && !data) {
    return
  }

  if (items) {
    elements = items
  }

  if (!items && data) {
    elements = data.map(item => ({
      text: item.text,
      href: item.href,
    }))
  }

  return (
    <Wrapper>
      <ListWrapper itemScope itemType="http://schema.org/BreadcrumbList" aria-label="Breadcrumb">
        {elements.map((item, index) => (
          <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem" key={index}>
            <ButtonElement itemProp="item" href={item.href} as="a" $type="transparentNeutral" $size="XS">
              {elements.length - 1 === index
                ? (
                    <Typography $variant="body-s-regular-flat" as="span" itemProp="name" aria-current="page">
                      {item.text}
                    </Typography>
                  )
                : (
                    <>
                      <Typography $variant="body-s-regular-flat"as="span" itemProp="name">
                        {item.text}
                      </Typography>
                      <Icon glyph="ChevronRightExtraSmall" size={20} />
                    </>
                  )}
            </ButtonElement>
            <meta itemProp="position" content={`${index + 1}`} />
          </li>
        ))}
      </ListWrapper>
      <StyledLine />
    </Wrapper>

  )
}
